module.exports = __webpack_public_path__ + "img/list-pattern3.2f4e417.svg";